import { HStack, Box, Text, DataList, DataItem } from '@cad-arc';
import { RelatedDataEntity } from '@mark43/cad-api';
import { relatedDataUtils } from '../../../related-data';
import { NarrativePopover } from '../../../related-data/narrative-popover';
import { DATA_ITEM_LINE_HEIGHT } from './constants';
import { AdditionalDispositionsPopover } from './popovers/additional-dispositions-popover';
import { MatchingCriteriaPopover } from './popovers/matching-criteria-popover';
import { LinkText } from '../../../common/components/link-text';
import { formatMonthDayYearHoursMinutes } from '../../../common/helpers/utils';
import { FR_EVENT_DETAILS_TABS } from '../../../fr-event-details-page/constants';
import { useOpenEvent } from '../../../common/hooks/use-open-event';

const { buildMatchingCriteriaString } = relatedDataUtils;

export const CadEventRow = ({ entity }: { entity: RelatedDataEntity }) => {
    const matchingCriteria = buildMatchingCriteriaString(entity.relatedDataMatchingCriteria);

    const onClickEventNumber = useOpenEvent();

    return (
        <HStack width="100%" align="top" data-testid="RELATED_DATA_CAD_EVENT_ROW">
            <Box width="55%">
                <DataList variant="inline" spacing="1">
                    <DataItem dataKey="Event #">
                        <LinkText
                            data-testid="related-event-link"
                            fontSize="sm"
                            onClick={(e) => {
                                e.stopPropagation();
                                onClickEventNumber({
                                    eventId: entity.entityId,
                                    frEventDetailsTabName: FR_EVENT_DETAILS_TABS.EVENT_INFO,
                                });
                            }}
                        >
                            {entity.entityNumber}
                        </LinkText>
                    </DataItem>
                    <DataItem dataKey="CFS">{entity.title}</DataItem>
                    <DataItem dataKey="Match">
                        <Text>
                            {matchingCriteria} <MatchingCriteriaPopover cadEvent={entity} />
                        </Text>
                    </DataItem>
                </DataList>
            </Box>
            <Box width="45%">
                <DataList variant="inline" spacing="1">
                    <DataItem dataKey="Created">
                        {formatMonthDayYearHoursMinutes(entity.createdDateUtc)}
                    </DataItem>
                    <DataItem dataKey="Disposition">
                        {entity.disposition && (
                            <Text
                                as="span"
                                variant="bodyMd"
                                style={{
                                    lineHeight: DATA_ITEM_LINE_HEIGHT,
                                }}
                            >
                                {entity.disposition}
                                {entity.additionalDispositions.length > 0 && (
                                    <>
                                        , <AdditionalDispositionsPopover cadEvent={entity} />
                                    </>
                                )}
                            </Text>
                        )}
                    </DataItem>
                    <Box
                        style={{
                            lineHeight: DATA_ITEM_LINE_HEIGHT,
                        }}
                    >
                        {entity.narrative && <NarrativePopover narrative={entity.narrative} />}
                    </Box>
                </DataList>
            </Box>
        </HStack>
    );
};
